import { data, user } from 'services';
import { getCategoryById, getVehicleClassById, getDate } from 'services/types';
import { ParkingCell } from 'libs/ui';
import { DelSetForm, StatusSetForm, TariffSetForm, ClassSetForm, CategorySetForm } from 'libs/forms';

export const getTableParams = (t) => {
  const setRight = user.haveRight('rfid.bulk');
  const setActions = setRight
    ? [
        {
          title: 'Удалить',
          key: 'del',
          form: DelSetForm,
          simple: true,
          method: 'rfid.bulk_delete',
          idsParam: 'ids',
          isDanger: true,
        },
        {
          title: 'Статус',
          key: 'status',
          form: StatusSetForm,
          dict: 'rfid.status',
          simple: false,
          method: 'rfid.bulk_change_status',
          idsParam: 'ids',
        },
        {
          title: 'Тариф',
          key: 'tariff',
          form: TariffSetForm,
          dict: 'rfid.status',
          simple: false,
          method: 'rfid.bulk_update_tariff',
          idsParam: 'ids',
        },
        {
          title: 'Класс ТС',
          key: 'tsclass',
          form: ClassSetForm,
          simple: false,
          method: 'rfid.bulk_change_vehicle_class',
          idsParam: 'ids',
        },
        {
          title: 'Категория',
          key: 'tscategory',
          form: CategorySetForm,
          simple: false,
          method: 'rfid.bulk_change_vehicle_category',
          idsParam: 'ids',
        },
      ]
    : [];

  const fields = [
    { name: 'rfid', title: t('sections.RFID'), width: 120, sortField: 'rfid' },
    { name: 'vehicle_plate', title: t('sections.ГРЗ'), width: 130, sortField: 'vehicle_plate' },
    {
      name: 'status',
      title: t('grid.Статус'),
      width: 145,
      sortField: 'status',
      render: (val) => data.getDictValue('rfid.status', val),
    },
    {
      name: 'start_at',
      title: t('form.Дата действия с'),
      width: 210,
      sortField: 'start_at',
      render: (val) => getDate(val),
    },
    {
      name: 'end_at',
      title: t('form.Дата действия по'),
      width: 230,
      sortField: 'end_at',
      render: (val) => getDate(val),
    },
    { name: 'owner', title: t('form.Держатель'), sortField: 'owner' },
    { name: 'client_name', title: t('form.Клиент'), width: 147, sortField: 'client_name' },
    {
      name: 'vehicle_class',
      title: t('dict_filter.Класс ТС'),
      width: 112,
      sortField: 'vehicle_class',
      render: (val) => getVehicleClassById(val),
    },
    {
      name: 'vehicle_category',
      title: t('form.Категория'),
      width: 112,
      sortField: 'vehicle_category',
      render: (val) => getCategoryById(val),
    },
    { name: 'tariff', title: t('form.Тариф'), width: 180 },
    { name: 'comment', title: t('filter.Комментарий'), width: 150 },
  ];

  if (window.config.central) {
    fields.unshift({
      name: 'parking_id',
      title: t('grid.Парковка'),
      render: (val) => <ParkingCell parking_id={val} cmp={'span'} />,
      width: 140,
    });
  }

  // get row class
  const getRowClass = (row) => {
    let out = '';
    out += ' ' + row.status;
    return out;
  };

  return { fields, getRowClass, withComment: true, setActions };
};
